import { observer } from "mobx-react";
import { FormPage } from "../../../../stores/models/FormPage";
import DialogFormSection from "./DialogFormSection";
import { Fragment } from "react";

interface DialogFormPageProps {
    page: FormPage;
}

const DialogFormPage = observer((props: DialogFormPageProps) => {

    /********* Render *********/

    return (
        <Fragment>
            {props.page.sections.map((section, index) => {
                return (
                    <DialogFormSection section={section} />
                )
            })}
        </Fragment>
    );
});

export default DialogFormPage;